module.exports = __webpack_public_path__ + "img/left.79a566d8.png";